export const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '38px',
    height: '38px', // Increased from 31px to accommodate floating label
    padding: '12px 10px 4px 10px', // Added top padding for floating label
    borderRadius: '0.4rem',
    border: state.isFocused ? '1px solid #335797' : '1px solid #ccc',
    boxShadow: state.isFocused ? '0 0 2px rgba(51, 87, 151, 0.5)' : 'none',
    fontSize: '14px',
    color: '#6b7280',
    '&:hover': {
      borderColor: state.isFocused ? '#335797' : '#ccc',
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: '22px', // Reduced from 28px to make room for label
    padding: '0 6px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '2px',
  }),

  // Enhanced multi-value styling for selected items
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f2fe',
    borderRadius: '4px',
    border: '1px solid #335797',
    margin: '1px',
    fontSize: '12px',
    maxHeight: '22px',
    display: 'flex',
    alignItems: 'center',
  }),

  multiValueLabel: (provided) => ({
    ...provided,
    color: '#0f172a',
    fontSize: '12px',
    padding: '2px 4px',
    fontWeight: '500',
  }),

  multiValueRemove: (provided) => ({
    ...provided,
    color: '#64748b',
    backgroundColor: 'transparent',
    borderRadius: '4px',
    padding: '0 2px',
    '&:hover': {
      backgroundColor: '#ea7777ff',
      color: 'white',
    },
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    display: 'none',
  }),

  singleValue: (provided) => ({
    ...provided,
    lineHeight: '22px', // Adjusted to match new valueContainer height
    color: '#6b7280',
    margin: '0',
  }),

  placeholder: (provided) => ({
    ...provided,
    lineHeight: '22px', // Adjusted to match new valueContainer height
    color: '#6b7280',
    margin: '0',
    // fontStyle: 'italic',
  }),

  // Enhanced input styling
  input: (provided) => ({
    ...provided,
    margin: '0',
    padding: '0',
    color: '#6b7280',
    fontSize: '14px',
  }),

  // Enhanced menu styling
  menu: (provided) => ({
    ...provided,
    borderRadius: '0.4rem',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
    marginTop: '2px',
  }),

  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    maxHeight: '200px',
  }),

  // Enhanced option styling
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#335797' : state.isFocused ? '#f0f9ff' : 'transparent',
    color: state.isSelected ? 'white' : '#374151',
    padding: '8px 12px',
    borderRadius: '4px',
    margin: '1px 0',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: state.isSelected ? '#335797' : '#e0f2fe',
    },
  }),

  // Enhanced no options message
  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#9ca3af',
    fontSize: '14px',
    padding: '12px',
    textAlign: 'center',
    fontStyle: 'italic',
  }),

  // Enhanced loading message
  loadingMessage: (provided) => ({
    ...provided,
    color: '#6b7280',
    fontSize: '14px',
    padding: '12px',
    textAlign: 'center',
  }),

  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};
